import { render } from "./CommentSectionModal.vue?vue&type=template&id=3b3b9abd"
import script from "./CommentSectionModal.vue?vue&type=script&lang=js"
export * from "./CommentSectionModal.vue?vue&type=script&lang=js"

import "./CommentSectionModal.vue?vue&type=style&index=0&id=3b3b9abd&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__